export const BASE_PIXELS = 16

function rem(valueInPixels: number | string, base = BASE_PIXELS): string {
  return `${parseInt(String(valueInPixels), 10) / base}rem`
}

export default rem
